import { ajaxAuth } from '../gateway'
import store from '@/store'

function orderDevicesByOwner (a, b) {
  return ((a.ownerName || a.device).toLowerCase() > (b.ownerName || b.device).toLowerCase()) ? 1 : -1
}

/**
 * Returns all devices in the system
 */
export function listAllDevices () {
  return ajaxAuth.post('/devices/_all', {})
    .then(d => {
      return Object.values(d).sort(orderDevicesByOwner)
    }) // order by ownerName, coalesced by device/IMEI
}


export function startBackgroundMonitor (intervalInMs) {
  const task = async () => {
    if (store.state.auth.access_token != null) {
      const devices = await listAllDevices()
      store.commit('deviceCache/setDevices', devices)
    }
  }
  // now
  task()
  // ongoing
  return setInterval(async () => {
    await task()
  }, intervalInMs)
}